// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"gZ-z","subtitle":"hZ-z","wrapper":"iZ-z","leftArrow":"jZ-z","rightArrow":"kZ-z"};